module.exports = __webpack_public_path__ + "img/Chongqing_University_Logo.63010d54.png";